import type { CampaignSchedule } from '@k2/domain/campaign-plan'
import { useApi } from '@/api'

export const useCampaignsResource = () => {
  const api = useApi()
  const campaignsOf = (organizationId: string, brandId: string) =>
    api.api.v1.organizations({ organizationId }).brands({ brandId }).campaigns
  const campaignOf = (organizationId: string, campaignId: string) => api.api.v1.organizations({ organizationId }).campaigns({ campaignId })

  return {
    getCampaign: (organizationId: string, campaignId: string) => campaignOf(organizationId, campaignId).get(),
    getCampaigns: (organizationId: string, brandId: string) => campaignsOf(organizationId, brandId).get(),
    getRecentCampaigns: (organizationId: string) => api.api.v1.organizations({ organizationId })['recent-campaigns'].get(),
    setCampaign: (organizationId: string, brandId: string) => campaignsOf(organizationId, brandId).post({}),
    setCampaignName: (organizationId: string, campaignId: string, name: string) => campaignOf(organizationId, campaignId).patch({ name }),
    setSchedule: (organizationId: string, campaignId: string, schedule: CampaignSchedule) =>
      campaignOf(organizationId, campaignId).schedule.put(schedule),
    setSignOff: (organizationId: string, campaignId: string) => campaignOf(organizationId, campaignId)['sign-off'].post(),
    setBriefSection: (organizationId: string, campaignId: string, heading: string, body: string) =>
      campaignOf(organizationId, campaignId).brief.sections.put({ heading, body }),
    setBriefField: (organizationId: string, campaignId: string, field: 'insight' | 'proposition', value: string) =>
      campaignOf(organizationId, campaignId).brief.fields.put({ field, value })
  }
}
